module.exports = __webpack_public_path__ + "static/img/206.7df90ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/190926/206.jpg
// module id = ZXWX
// module chunks = 0